import { Injectable } from '@angular/core';
import { ValueFunctionMap } from '../_models/valueFunctionMap';
import { DeviceTypeList } from '../../../assets/data/enum/deviceTypeList';

@Injectable()
export class DeviceDataMapperService {
  mapping: object = {};
  frontGraph: object = {};

  DeviceDataMapperService() {
    this.mapSoilWatch();
    this.mapTeros10();
    this.mapTeros12();
    this.mapDavisSolarShield();
    this.mapLiquidPhMeter();
    this.mapPhytos31();
    this.mapWaterPlumb();
    this.mapSentek30();
    this.mapSentek60();
    this.mapSentek90();
    this.mapGPS();
  }

  initialize() {
    this.mapSoilWatch();
    this.mapTeros10();
    this.mapTeros12();
    this.mapDavisSolarShield();
    this.mapLiquidPhMeter();
    this.mapPhytos31();
    this.mapWaterPlumb();
    this.mapSentek30();
    this.mapSentek60();
    this.mapSentek90();
    this.mapGPS();
  }

  mapSoilWatch() {
    const soilMostureFunctionSoilWatch = function (mr) {
      let result = 14.1 * (mr / 1000) - 4.1;
      if (result < 0) {
        result = 0;
      }
      return result;
    };
    const mr1VF: ValueFunctionMap = new ValueFunctionMap('mr1', soilMostureFunctionSoilWatch);
    const mr2VF: ValueFunctionMap = new ValueFunctionMap('mr2', soilMostureFunctionSoilWatch);
    const st1VF: ValueFunctionMap = new ValueFunctionMap('st1', null);
    const st2VF: ValueFunctionMap = new ValueFunctionMap('st2', null);
    const vfArray = [mr1VF, mr2VF, st1VF, st2VF];
    this.mapping[DeviceTypeList.X_NODE_SOILWATCH_10_SINGLE] = vfArray;
    this.frontGraph[DeviceTypeList.X_NODE_SOILWATCH_10_SINGLE] = ['mr', 'st'];
    this.mapping[DeviceTypeList.X_NODE_SOILWATCH_10_DOUBLE] = vfArray;
    this.frontGraph[DeviceTypeList.X_NODE_SOILWATCH_10_DOUBLE] = ['mr', 'st'];
  }

  mapTeros10() {
    const soilMostureFunctionTeros10 = function (mr) {
      let result = Math.round(
        (4.824 * Math.pow(10, -10) * Math.pow(mr, 3) -
          2.278 * Math.pow(10, -6) * Math.pow(mr, 2) +
          3.898 * Math.pow(10, -3) * mr -
          2.154) *
          100
      );
      if (result < 0) {
        result = 0;
      }
      return result;
    };
    const mr1VF: ValueFunctionMap = new ValueFunctionMap('mr1', soilMostureFunctionTeros10);
    const mr2VF: ValueFunctionMap = new ValueFunctionMap('mr2', soilMostureFunctionTeros10);
    const vfArray = [mr1VF, mr2VF];
    this.mapping[DeviceTypeList.X_NODE_TEROS_10_SINGLE] = vfArray;
    this.frontGraph[DeviceTypeList.X_NODE_TEROS_10_SINGLE] = ['mr'];
    this.mapping[DeviceTypeList.X_NODE_TEROS_10_DOUBLE] = vfArray;
    this.frontGraph[DeviceTypeList.X_NODE_TEROS_10_DOUBLE] = ['mr'];
  }

  mapTeros12() {
    const soilMostureFunctionTeros12 = function (mr) {
      let result = Math.round((3.879 * Math.pow(10, -4) * mr - 0.6956) * 100);
      if (result < 0) {
        result = 0;
      }
      return result;
    };
    const mr1VF: ValueFunctionMap = new ValueFunctionMap('mr1', soilMostureFunctionTeros12);
    const mr2VF: ValueFunctionMap = new ValueFunctionMap('mr2', soilMostureFunctionTeros12);

    const ss1VF: ValueFunctionMap = new ValueFunctionMap('ss1', null);
    const ss2VF: ValueFunctionMap = new ValueFunctionMap('ss2', null);

    const st1VF: ValueFunctionMap = new ValueFunctionMap('st1', null);
    const st2VF: ValueFunctionMap = new ValueFunctionMap('st2', null);

    const vfArray = [mr1VF, mr2VF, ss1VF, ss2VF, st1VF, st2VF];
    this.mapping[DeviceTypeList.X_NODE_TEROS_12_SINGLE] = vfArray;
    this.frontGraph[DeviceTypeList.X_NODE_TEROS_12_SINGLE] = ['mr', 'st'];
    this.mapping[DeviceTypeList.X_NODE_TEROS_12_DOUBLE] = vfArray;
    this.frontGraph[DeviceTypeList.X_NODE_TEROS_12_DOUBLE] = ['mr', 'st'];
  }

  mapDavisSolarShield() {
    const atVF: ValueFunctionMap = new ValueFunctionMap('at', null);
    const ah2VF: ValueFunctionMap = new ValueFunctionMap('ah', null);
    const atdVF: ValueFunctionMap = new ValueFunctionMap('atd', null);
    const vfArray = [atVF, ah2VF, atdVF];
    this.mapping[DeviceTypeList.X_SENSE_PRO_DAVIS] = vfArray;
    this.frontGraph[DeviceTypeList.X_SENSE_PRO_DAVIS] = ['at', 'atd'];
  }

  mapLiquidPhMeter() {
    const lwVF: ValueFunctionMap = new ValueFunctionMap('lw', null);
    const wm1VF: ValueFunctionMap = new ValueFunctionMap('wm1', null);
    const wm2VF: ValueFunctionMap = new ValueFunctionMap('wm2', null);
    const vfArray = [lwVF, wm1VF, wm2VF];
    this.mapping[DeviceTypeList.X_NODE_PHYTOS_31] = vfArray;
    this.frontGraph[DeviceTypeList.X_NODE_PHYTOS_31] = ['lw', 'wm1'];
  }

  mapPhytos31() {
    const phVF: ValueFunctionMap = new ValueFunctionMap('ph', null);
    const nt1VF: ValueFunctionMap = new ValueFunctionMap('nt1', null);
    const vfArray = [phVF, nt1VF];
    this.mapping[DeviceTypeList.X_NODE_PH_PROTOTYPE] = vfArray;
    this.frontGraph[DeviceTypeList.X_NODE_PH_PROTOTYPE] = ['ph', 'nt1'];
  }

  mapWaterPlumb() {
    const llVF: ValueFunctionMap = new ValueFunctionMap('ll', null);
    const nt1VF: ValueFunctionMap = new ValueFunctionMap('nt1', null);
    const vfArray = [llVF, nt1VF];
    this.mapping[DeviceTypeList.X_NODE_WATER] = vfArray;
    this.frontGraph[DeviceTypeList.X_NODE_WATER] = ['ll', 'nt1'];
  }

  mapSentek30() {
    const st1VF: ValueFunctionMap = new ValueFunctionMap('st1', null);
    const st2VF: ValueFunctionMap = new ValueFunctionMap('st2', null);
    const st3VF: ValueFunctionMap = new ValueFunctionMap('st3', null);

    const sm1VF: ValueFunctionMap = new ValueFunctionMap('sm1', null);
    const sm2VF: ValueFunctionMap = new ValueFunctionMap('sm2', null);
    const sm3VF: ValueFunctionMap = new ValueFunctionMap('sm3', null);

    const ss1VF: ValueFunctionMap = new ValueFunctionMap('ss1', null);
    const ss2VF: ValueFunctionMap = new ValueFunctionMap('ss2', null);
    const ss3VF: ValueFunctionMap = new ValueFunctionMap('ss3', null);

    const vfArray = [st1VF, st2VF, st3VF, sm1VF, sm2VF, sm3VF, ss1VF, ss2VF, ss3VF];
    this.mapping[DeviceTypeList.X_NODE_SENTEK_30] = vfArray;
    this.frontGraph[DeviceTypeList.X_NODE_SENTEK_30] = ['st', 'sm'];
    this.mapping[DeviceTypeList.X_NODE_SENTEK_30_TRISCAN] = vfArray;
    this.frontGraph[DeviceTypeList.X_NODE_SENTEK_30_TRISCAN] = ['st', 'sm'];
  }

  mapSentek60() {
    const st1VF: ValueFunctionMap = new ValueFunctionMap('st1', null);
    const st2VF: ValueFunctionMap = new ValueFunctionMap('st2', null);
    const st3VF: ValueFunctionMap = new ValueFunctionMap('st3', null);
    const st4VF: ValueFunctionMap = new ValueFunctionMap('st4', null);
    const st5VF: ValueFunctionMap = new ValueFunctionMap('st5', null);
    const st6VF: ValueFunctionMap = new ValueFunctionMap('st6', null);

    const sm1VF: ValueFunctionMap = new ValueFunctionMap('sm1', null);
    const sm2VF: ValueFunctionMap = new ValueFunctionMap('sm2', null);
    const sm3VF: ValueFunctionMap = new ValueFunctionMap('sm3', null);
    const sm4VF: ValueFunctionMap = new ValueFunctionMap('sm4', null);
    const sm5VF: ValueFunctionMap = new ValueFunctionMap('sm5', null);
    const sm6VF: ValueFunctionMap = new ValueFunctionMap('sm6', null);

    const ss1VF: ValueFunctionMap = new ValueFunctionMap('ss1', null);
    const ss2VF: ValueFunctionMap = new ValueFunctionMap('ss2', null);
    const ss3VF: ValueFunctionMap = new ValueFunctionMap('ss3', null);
    const ss4VF: ValueFunctionMap = new ValueFunctionMap('ss4', null);
    const ss5VF: ValueFunctionMap = new ValueFunctionMap('ss5', null);
    const ss6VF: ValueFunctionMap = new ValueFunctionMap('ss6', null);

    const vfArray = [
      st1VF,
      st2VF,
      st3VF,
      st4VF,
      st5VF,
      st6VF,
      sm1VF,
      sm2VF,
      sm3VF,
      sm4VF,
      sm5VF,
      sm6VF,
      ss1VF,
      ss2VF,
      ss3VF,
      ss4VF,
      ss5VF,
      ss6VF,
    ];
    this.mapping[DeviceTypeList.X_NODE_SENTEK_60] = vfArray;
    this.frontGraph[DeviceTypeList.X_NODE_SENTEK_60] = ['st', 'sm'];
    this.mapping[DeviceTypeList.X_NODE_SENTEK_60_TRISCAN] = vfArray;
    this.frontGraph[DeviceTypeList.X_NODE_SENTEK_60_TRISCAN] = ['st', 'sm'];
  }

  mapSentek90() {
    const st1VF: ValueFunctionMap = new ValueFunctionMap('st1', null);
    const st2VF: ValueFunctionMap = new ValueFunctionMap('st2', null);
    const st3VF: ValueFunctionMap = new ValueFunctionMap('st3', null);
    const st4VF: ValueFunctionMap = new ValueFunctionMap('st4', null);
    const st5VF: ValueFunctionMap = new ValueFunctionMap('st5', null);
    const st6VF: ValueFunctionMap = new ValueFunctionMap('st6', null);
    const st7VF: ValueFunctionMap = new ValueFunctionMap('st7', null);
    const st8VF: ValueFunctionMap = new ValueFunctionMap('st8', null);
    const st9VF: ValueFunctionMap = new ValueFunctionMap('st9', null);

    const sm1VF: ValueFunctionMap = new ValueFunctionMap('sm1', null);
    const sm2VF: ValueFunctionMap = new ValueFunctionMap('sm2', null);
    const sm3VF: ValueFunctionMap = new ValueFunctionMap('sm3', null);
    const sm4VF: ValueFunctionMap = new ValueFunctionMap('sm4', null);
    const sm5VF: ValueFunctionMap = new ValueFunctionMap('sm5', null);
    const sm6VF: ValueFunctionMap = new ValueFunctionMap('sm6', null);
    const sm7VF: ValueFunctionMap = new ValueFunctionMap('sm7', null);
    const sm8VF: ValueFunctionMap = new ValueFunctionMap('sm8', null);
    const sm9VF: ValueFunctionMap = new ValueFunctionMap('sm9', null);

    const ss1VF: ValueFunctionMap = new ValueFunctionMap('ss1', null);
    const ss2VF: ValueFunctionMap = new ValueFunctionMap('ss2', null);
    const ss3VF: ValueFunctionMap = new ValueFunctionMap('ss3', null);
    const ss4VF: ValueFunctionMap = new ValueFunctionMap('ss4', null);
    const ss5VF: ValueFunctionMap = new ValueFunctionMap('ss5', null);
    const ss6VF: ValueFunctionMap = new ValueFunctionMap('ss6', null);
    const ss7VF: ValueFunctionMap = new ValueFunctionMap('ss7', null);
    const ss8VF: ValueFunctionMap = new ValueFunctionMap('ss8', null);
    const ss9VF: ValueFunctionMap = new ValueFunctionMap('ss9', null);

    const vfArray = [
      st1VF,
      st2VF,
      st3VF,
      st4VF,
      st5VF,
      st6VF,
      st7VF,
      st8VF,
      st9VF,
      sm1VF,
      sm2VF,
      sm3VF,
      sm4VF,
      sm5VF,
      sm6VF,
      sm7VF,
      sm8VF,
      sm9VF,
      ss1VF,
      ss2VF,
      ss3VF,
      ss4VF,
      ss5VF,
      ss6VF,
      ss7VF,
      ss8VF,
      ss9VF,
    ];
    this.mapping[DeviceTypeList.X_NODE_SENTEK_90] = vfArray;
    this.frontGraph[DeviceTypeList.X_NODE_SENTEK_90] = ['st', 'sm'];
    this.mapping[DeviceTypeList.X_NODE_SENTEK_90_TRISCAN] = vfArray;
    this.frontGraph[DeviceTypeList.X_NODE_SENTEK_90_TRISCAN] = ['st', 'sm'];
  }

  mapGPS() {
    const posVF: ValueFunctionMap = new ValueFunctionMap('pos', null);
    const vfArray = [posVF];
    this.mapping[DeviceTypeList.X_NODE_GPS_PROTOTYPE] = vfArray;
  }

  show(type, param) {
    const currentMapping = this.mapping[type];
    if (!currentMapping) {
      return null;
    }
    const values = currentMapping.map((vf) => vf.value);
    return values.indexOf(param) > -1;
  }

  getValue(type, param, value) {
    const currentMapping = this.mapping[type];
    for (let i = 0; i < currentMapping.length; i++) {
      if (currentMapping[i].value === param) {
        return currentMapping[i].calcFunction(value);
      }
    }

    return null;
  }

  getListCharts(type) {
    return this.frontGraph[type];
  }
}
